<template>
  <div class="landingpage container">
    <h1>{{ msg }}</h1>
    <p>
      EDR is a third party <router-link to="/edmc-plugin">plugin</router-link>, a <router-link to="/discord-bot">discord bot</router-link> and a <router-link to="/discord">community</router-link> for Elite: Dangerous. The objective is to provide in-game Intel about other commanders, <abbr title="Situation Report">Sitrep</abbr> and other helpful guidance.
    </p>
    <div class="video-container">
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/videoseries?list=PLOYEmG-ofHtNaOegmwXz0uXIQkyAyNsZM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  props: {
    msg: String
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px; height: 0; overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>